<template>
  <div>
    <div class="secondhead-text" data-cy="header-fieldworks">
      {{ setHeader }}
    </div>
    <div v-if="show_full_header" class="header-links">
      <router-link :to="setLink.to">
        <button class="link" :disabled="setLink.disabled" :title="setLink.title">
          <font-awesome-icon
            icon="spinner"
            spin
            aria-label="application is loading"
            v-if="is_progress_loading && setLink.loader"
          />
            {{ setLink.text }}
        </button>
      </router-link>
      <div
        v-if="
          this.$store.state.user_selected_term.name ===
          this.lookup_current_term.name
        "
        class="inline"
      >
        <router-link to="/fieldworks/add">
          <button class="link button">Add Entry</button>
        </router-link>
      </div>
    </div>
    <div v-if="show_full_header" :class="showDescription ? '' : 'hidden'">
      Track your progress for most recent entries.
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "MyFieldworksHeader",
  props: {
    show_full_header: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    setHeader: function () {
      return this.$route.path === "/" ? "Fieldwork Entries" : "My Entries";
    },
    showDescription: function () {
      return this.$route.path === "/";
    },
    setLink: function () {
      return this.$route.path === "/"
        ? {
            to: "/fieldworks",
            text: "View All",
            disabled: false,
            title: "View All Fieldworks"
          }
        : {
            to: "/fieldworks/print",
            text: "Print",
            disabled: this.is_progress_loading,
            loader: true,
            title: this.is_progress_loading ? 'Loading Progress': "Print Fieldwork Progress"
          };
    },
    ...mapGetters(["lookup_current_term", "is_progress_loading"]),
  },
};
</script>

<style scoped></style>
